// Which Mercado Libre account every screen is looking at.
//
// Kept in localStorage rather than in React state so a reload, a second tab
// or a deep link all land on the same brand, and read by the axios
// interceptor so no page has to remember to pass it along.
const KEY = 'meli_account_id';

export const getAccountId = () => {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    // Private windows can refuse storage entirely; falling back to the
    // server's active account is better than a blank screen.
    return null;
  }
};

export const setAccountId = (accountId) => {
  try {
    if (accountId) localStorage.setItem(KEY, accountId);
    else localStorage.removeItem(KEY);
  } catch {
    /* nothing to do: the request simply goes out unscoped */
  }
};

export const clearAccountId = () => setAccountId(null);
